import { Component, Injectable, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from '../../../_common/_service/authservice.service';
import { TokenStorageService } from '../../../_common/_service/token-storage.service';
import { ConfirmPasswordDialogComponent } from '../../popup/confirm-password-dialog/confirm-password-dialog.component';

import { JsonObject } from '@angular-devkit/core';
import { PaymentConfirmDialogComponent } from '../../popup/payment-confirm-dialog/payment-confirm-dialog.component';
import { CommonService } from "../../../_common/_service/user.service";
import { AuthenticationService } from '../../../_common/_service/authentication.service';
import { BeforePaymentConfirmDialogComponent } from '../../popup/beforepayment-confirm-dialog/beforepayment-confirm-dialog.component';
import { formatDate } from '@angular/common';
import { DateAdapter, MAT_DATE_FORMATS, NativeDateAdapter } from '@angular/material/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { HttpParams } from '@angular/common/http';

export const PICK_FORMATS = {
  parse: { dateInput: { month: 'short', year: 'numeric', day: 'numeric' } },
  display: {
    dateInput: 'input',
    monthYearLabel: { year: 'numeric', month: 'short' },
    dateA11yLabel: { year: 'numeric', month: 'long', day: 'numeric' },
    monthYearA11yLabel: { year: 'numeric', month: 'long' }
  }
};

@Injectable()
class PickDateAdapter extends NativeDateAdapter {
  format(date: Date, displayFormat: Object): string {
    if (displayFormat === 'input') {
      return formatDate(date, 'dd-MM-yyyy', this.locale);
    } else {
      return date.toDateString();
    }
  }
}

@Component({
  selector: 'app-beneficiarymobilemoney',
  templateUrl: './beneficiarymobilemoney.component.html',
  styleUrls: ['./beneficiarymobilemoney.component.scss'],
  providers: [
    { provide: DateAdapter, useClass: PickDateAdapter },
    { provide: MAT_DATE_FORMATS, useValue: PICK_FORMATS }
  ]
})

export class BeneficiaryMobilemoneyComponent implements OnInit {
  
  userorderdetailList: any;
  stringJson: any;
  stringObject: any;
  submitted = false;
  countryCode: any;
  channelList: any;
  balance: any;
  ServiceName: any;
  cUser: any;
  finalAmount: any;
  commissionFee: any;
  commissionTotal: any;
  amt: any;
  data: any;
  commissionList: any;
  recentReceiver: any;
  mobileMoneyBeneficiaryForm: FormGroup;
  maxDate = new Date();
  currentUser: any;
  token: any;
  OptionList: any;
  UsertBal: any;
  serviceCode: any;
  OperatorName: any;
  Idprooflist: any;
  BeneficiaryTypelist: any;
  BeneficiaryRelationshiplist: any;
  countryISDCode: any;
  OtherRemarkslist: any;
  purposeofremittancelist: any;
  senderSourceOfFundlist: any;
  loadingspinner: boolean = false;

  public CountryFilterCtrl: FormControl = new FormControl();
  protected _onDestroy = new Subject<void>();    
  
  constructor(private authService: AuthService, private router: Router,
    private route: ActivatedRoute, public dialog: MatDialog,
    private fb: FormBuilder,
    private toastr: ToastrService, private tokenStorageService: TokenStorageService, private tokenService: AuthenticationService,
    private _service: CommonService) {


    this.mobileMoneyBeneficiaryForm = this.fb.group({
      beneficiary_type: [null, [Validators.required]],
      beneficiary_service_Accountcode: [null],
      beneficiary_country_Accountcode: [null, [Validators.required]],
      channel_Code: [null, [Validators.required]],
      beneficiary_fname: [null, [Validators.required, Validators.pattern("^[a-zA-Z ]*$")]],
      beneficiary_lname: [null, [Validators.required, Validators.pattern("^[a-zA-Z ]*$")]],
      beneficiary_address: [null, [Validators.required]],
      beneficiary_phone: [null, [Validators.required, Validators.pattern("^[0-9]*$"), Validators.maxLength(20), Validators.minLength(1)]],
      beneficiary_email: [null, [Validators.required, Validators.email]],
      beneficiary_relationship: [null, [Validators.required]],
      beneficiary_id: [null, [Validators.required]],
      beneficiary_id_number: [null, [Validators.required]],
      beneficiary_Other_Remarks: [],
      beneficiary_account_no: [null], // if mobilemon u haveto pass mobileno. -if bank then bank account no.-if ezipey wallet userid 
      beneficiary_bank_code: [null],  // for bank code onli
      beneficiary_nationality: [null], //for county dropdown list fotr benficifiaery user :- country code :- gh
      senderSourceOfFund: [null, [Validators.required]],
      purposeofremittance: [null, [Validators.required]],
      account_options: [null] //mtn,vodafone
    })

  }

  
  ngOnInit(): void {  
    
    this.token = this.tokenStorageService.getToken();
     this.serviceCode = this.route.snapshot.queryParams.serviceCode;
    if (this.token) {
      this.currentUser = this.tokenStorageService.getUser();
      //this.UsertBal = this.tokenStorageService.getUsertBal();

      this.getcountryList();
      this.getIdprooflist();
      this.GetBeneficiaryRelationship();
      this.GetBeneficiaryType();   
      this.getpurposeofremittancelistLN();
      this.getsenderSourceOfFundlistLN();
      // listen for search field value changes
      this.CountryFilterCtrl.valueChanges
        .pipe(takeUntil(this._onDestroy))
        .subscribe(() => {
          this.filterCountry();
        });

    }
    else {
      this._service.callMethodOfSecondComponent();
    }


    
  }
  
  Back() {
    this.router.navigate(['/TransferToMobileMoney'], { queryParams: { serviceCode: this.serviceCode }, skipLocationChange: true });
  }

  get f() { return this.mobileMoneyBeneficiaryForm.controls; }

  
  submitMobileMoneyBeneficiaryForm(post: any) {
    //
    this.submitted = true;
    if (this.mobileMoneyBeneficiaryForm.valid) {
      this.loadingspinner = true;
      ////////console.log(post);
      debugger
      post.beneficiary_phone = this.countryISDCode + post.beneficiary_phone;
      post.beneficiary_account_no = post.beneficiary_phone;
      post.beneficiary_service_Accountcode = this.serviceCode;
      post.beneficiary_nationality = post.beneficiary_country_Accountcode;

      if (post.beneficiary_relationship == 'O') {  //onli in other case 
        post.beneficiary_relationship = post.beneficiary_Other_Remarks;
      }
     
      
      this.authService.submitMobileMoneyBeneficiary(post, this.currentUser.serviceid).subscribe((response: { apiStatus: boolean; apiMessage: string | undefined; apiData: any; transactionStatus: any }) => {
        
        this.loadingspinner = false;
        if (response.apiStatus == true) {
          this.submitted = false;
          this.toastr.success(response.apiMessage, 'Success');
          this.mobileMoneyBeneficiaryForm.reset();
        }
        else {
          this.toastr.error(response.apiMessage, 'Error');
        }
      }, (err: any) => {
        this.loadingspinner = false;
        if (err.error instanceof Error) {

          this.toastr.error(err.error, 'Error');
        } else {

          this.toastr.error(err.error, 'Error');
        }
      }
      );
    }
  }



  


  getcountryList() {
    this.submitted = false;

    this.authService.getchannelList(this.serviceCode, this.currentUser.serviceid).subscribe((response: { apiStatus: boolean; apiMessage: string | undefined; apiData: any; }) => {
      ;
      if (response.apiStatus == true) {
        this.OptionList = response.apiData;
        
      }
      else if (response.apiStatus == false) { //    "apiMessage": "user account is disable",
        this.toastr.warning(response.apiMessage, 'Warning');
        this._service.callMethodOfSecondComponent();
      }
      else {
        this.toastr.error(response.apiMessage, 'Error');
      }

    }, (err: any) => {
      if (err.error instanceof Error) {
        this.toastr.error(err.error, 'Error');
      } else {

        this.toastr.error(err.error, 'Error');
      }
    }
    );
  }

  GetCurrentchannelVal(code: any, countryISDCode: any) {

    this.submitted = false;
    this.f.channel_Code.setValue(null);
    this.countryISDCode = countryISDCode;
    
    this.authService.getchannelList(code, this.currentUser.serviceid).subscribe((response: { apiStatus: boolean; apiMessage: string | undefined; apiData: any; }) => {
      ;
      if (response.apiStatus == true) {

        this.channelList = response.apiData;
      }
      else if (response.apiStatus == false) {
        this.toastr.warning(response.apiMessage, 'Warning');
        this._service.callMethodOfSecondComponent();
      }
      else {
        this.toastr.error(response.apiMessage, 'Error');
      }

    }, (err: any) => {
      if (err.error instanceof Error) {
        this.toastr.error(err.error, 'Error');
      } else {

        this.toastr.error(err.error, 'Error');
      }
    }
    );
    this.GetMobileMoneyBeneficiaryDetails(code);
  }


  GetBeneficiaryType() {
    this.authService.GetBeneficiaryType().subscribe(response => {
      if (response) {
        this.BeneficiaryTypelist = response;
      }
      else {
        this.toastr.error('Error', 'Error');
      }
    }, (err: any) => {
      if (err.error instanceof Error) {
        this.toastr.error(err.error, 'Error');
      } else {
        this.toastr.error(err.error, 'Error');
      }
    });
  }

  GetBeneficiaryRelationship() {
    this.authService.GetBeneficiaryRelationship().subscribe(response => {
      if (response) {
        this.BeneficiaryRelationshiplist = response;
      }
      else {
        this.toastr.error('Error', 'Error');
      }
    }, (err: any) => {
      if (err.error instanceof Error) {
        this.toastr.error(err.error, 'Error');
      } else {
        this.toastr.error(err.error, 'Error');
      }
    });
  }

  getIdprooflist() {

    this.authService.GetkycType().subscribe(response => {
      if (response) {
        this.Idprooflist = response;
      }
      else {
        this.toastr.error('Error', 'Error');
      }

    }, (err: any) => {
      if (err.error instanceof Error) {
        this.toastr.error(err.error, 'Error');
      } else {
        this.toastr.error(err.error, 'Error');
      }
    });
  }


  GetMobileMoneyBeneficiaryDetails(code: any) { //countri code
    ;
    this.authService.GetMobileMoneyBeneficiaryDetails(code).subscribe(response => {
      ;
      this.userorderdetailList = response;

    }, (err: any) => {
      if (err.error instanceof Error) {
        this.toastr.error(err.error, 'Error');
      } else {
        this.toastr.error(err.error, 'Error');
      }
    }
    );
  }


  CheckBeneficiaryRelationship(code: any) {
    ;
    this.f.beneficiary_Other_Remarks.setValue(null);
    
    if (code == 'O') {
      
      this.authService.GetBeneficiaryRelationshipList().subscribe(response => {
        ;
        this.OtherRemarkslist = response;

      }, (err: any) => {
        if (err.error instanceof Error) {
          this.toastr.error(err.error, 'Error');
        } else {
          this.toastr.error(err.error, 'Error');
        }
      }
      );
    }
    else {
      this.OtherRemarkslist = null;
    }
  }

  filterCountry() {
   
    if (this.CountryFilterCtrl.value) {
      
      return this.OptionList.payservices.filter((x: { name: string; }) => x.name.toLowerCase().startsWith(this.CountryFilterCtrl.value.toLowerCase()));
    } else {
      return this.OptionList?.payservices;
    }
  }

  getsenderSourceOfFundlistLN() {
    debugger
    this.authService.getsenderSourceOfFundlistLN().subscribe(response => {
      debugger

      this.senderSourceOfFundlist = response.apiData.result.result;
 
    }, (err: any) => {
      if (err.error instanceof Error) {
        this.toastr.error(err.error, 'Error');
      } else {
        this.toastr.error(err.error, 'Error');
      }
    });
  }


  getpurposeofremittancelistLN() {

    this.authService.getpurposeofremittancelistLN().subscribe(response => {

      this.purposeofremittancelist = response.apiData.result.result;

    }, (err: any) => {
      if (err.error instanceof Error) {
        this.toastr.error(err.error, 'Error');
      } else {
        this.toastr.error(err.error, 'Error');
      }
    });
  }


}
